import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'src/environments/environment';
import { Observable, Subject, finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { RegistreService } from '../registre.service';
import { Generic, GenericRegister } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-registre-autorizari-comerciale',
    templateUrl: './registre-autorizari-comerciale.component.html',
    styleUrls: ['./registre-autorizari-comerciale.component.scss']
})
export class RegistreAutorizariComercialeComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Output() backToRegistreClicked = new EventEmitter();

    isLoading = false;
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    dtLanguage: any = {};

    dtLink = environment.interop.autcomCore.basePath + environment.interop.autcomCore.registre.getRegistreDT;

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    }

    registre$!: Observable<GenericRegister[]>;
    valabilitatiRegistru$!: Observable<Generic[]>;

    selectedRegistruId: number = -1;
    selectedValabilitate: number = -1;

    constructor(
        private http: HttpClient,
        private registreService: RegistreService,
    ) {
        this.dtLanguage = JSON.parse(JSON.stringify(environment.config.romanianLanguageDataTable));
        this.dtLanguage.sInfoFiltered = '';
    }

    ngOnInit(): void {
        this.loadRegistre();
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    loadRegistre() {
        this.registre$ = this.registreService
            .getRegistreAutorizari()
            .pipe(map((res: any) => [this.defaultParameter, ...res]));
    }

    onRegistruChange(registruId: number) {
        this.selectedRegistruId = registruId;
        this.selectedValabilitate = -1;

        if (this.selectedRegistruId !== -1) {
            this.findValabilitateByRegistru(registruId);
            // this.rerenderDT(true);
        } else {
            this.valabilitatiRegistru$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter])
                observer.complete();
            });
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.clear().destroy();
                this.dtTrigger.next('');
            });
        }
    }

    findValabilitateByRegistru(registruId: number) {
        this.isLoading = true;
        this.valabilitatiRegistru$ = this.registreService
            .getRegistreAutorizariValability(registruId)
            .pipe(
                map((results: Generic[]) => {
                    this.selectedValabilitate = results[0]?.id || -1;

                    return [...results];
                }),
                finalize(() => {
                    this.rerenderDT(true);
                    this.isLoading = false;
                })
            )
    }

    onValabilitateChange(selectedValabilitate: number) {
        this.selectedValabilitate = selectedValabilitate;

        if (this.selectedRegistruId !== -1 && this.selectedValabilitate !== -1) {
            this.rerenderDT(true);
        } else {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.clear().destroy();
                this.dtTrigger.next('');
            });
        }
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 100,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type = this.selectedRegistruId;
                dataTablesParameters.valabilitate = this.selectedValabilitate;

                this.http
                    .post<any>(
                        this.dtLink,
                        dataTablesParameters
                    )
                    .subscribe((res: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: res.data.recordsTotal,
                            recordsFiltered: res.data.recordsFiltered,
                            data: res.data.data,
                        });
                    });
            },
            language: this.dtLanguage,
            order: [[5, 'asc']],
            columns: [
                {
                    title: 'Crt.',
                    data: 'index',
                    orderable: false,
                },
                {
                    title: 'Denumire companie',
                    data: 'f_nume',
                    orderable: false,
                },
                {
                    title: 'Punct de lucru',
                    data: 'f_punct_lucru',
                    orderable: false,
                },
                {
                    title: 'CUI',
                    data: 'f_cui',
                    orderable: false,
                },
                {
                    title: 'Valabilitate',
                    data: 'valability',
                    orderable: false,
                    // render: (data: any, type: any, full: any) => {
                    //     if (type === 'display' && data) {
                    //         const dateParts = data.split('-');
                    //         return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
                    //     }
                    //     return data;
                    // },
                },
                {
                    title: 'Nr. acord/autorizație',
                    data: 'document_numar',
                    orderable: false,
                },
                {
                    title: 'Data emitere autorizație/acord',
                    data: 'document_data',
                    orderable: false,
                }
            ],
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    backToRegistre() {
        this.backToRegistreClicked.emit();
    }
}
